// eslint-disable

import { useQuery } from '@tanstack/react-query'
import { Pagination } from 'src/components/datagrid'
import { ITransactionItem } from 'src/types/transaction'
import { ICardBalance, ICardItem } from 'src/types/card'
import axiosInstance from 'src/utils/axios'

type Transactions = {
  data: ITransactionItem[]
  page: number
  perPage: number
  totalPages: number
  total: number
}

async function fetchUser(pagination: Pagination, id: string, filters: any): Promise<Transactions> {
  const res = await axiosInstance.get('/transaction', {
    params: {
      ...filters,
      ...pagination,
      card: id,
    },
  })
  return res.data
}

function useTransaction(pagination: Pagination, id: string, filters?: any) {
  return useQuery(
    ['transaction', pagination, filters, id],
    () => fetchUser(pagination, id, filters),
    {
      keepPreviousData: true,
      staleTime: 5000,
    },
  )
}

// Saldo / resumo do cartão (respeita filtro de período)
async function fetchBalance(id: string, filters?: any): Promise<ICardBalance> {
  const res = await axiosInstance.get(`/transaction/${id}/balance`, {
    params: {
      dateStart: filters?.dateStart,
      dateEnd: filters?.dateEnd,
    },
  })
  return res.data
}

export function useCardBalance(id: string, filters?: any) {
  return useQuery(['card-balance', id, filters], () => fetchBalance(id, filters), {
    keepPreviousData: true,
    staleTime: 5000,
    enabled: !!id,
  })
}

// Dados do cartão (nome, número, evento)
async function fetchCardInfo(id: string): Promise<ICardItem> {
  const res = await axiosInstance.get(`/card/${id}`)
  return res.data
}

export function useCardInfo(id: string) {
  return useQuery(['card-info', id], () => fetchCardInfo(id), {
    staleTime: 5000,
    enabled: !!id,
  })
}

export default useTransaction
